import { resolveFieldType } from "../forms/normalizeFieldType";
import { isListFieldType } from "./listChoicesMode";

export type ApiFieldTypeOption = {
  value: string;
  label: string;
  group?: string;
};

export const QUIZ_SCORE_FIELD_TYPE_GROUP = "С баллами";
export const QUIZ_OTHER_FIELD_TYPE_GROUP = "Без баллов";

const FIELD_TYPE_LABELS: Record<string, string> = {
  text: "Текст",
  email: "Email",
  textarea: "Многострочный",
  number: "Число",
  phone: "Телефон",
  date: "Дата",
  "date-range": "Интервал дат",
  birthdate: "Дата рождения",
  choice: "Выбор",
  select: "Выпадающий список",
  "multiple-choice": "Несколько вариантов",
  city: "Город",
  fio: "ФИО",
  privacy: "Согласие (ПДн)",
  display: "Оформление",
};

/** Типы из `App\Support\FormFieldTypes::TYPES` — отдельного API-роута нет. */
export const FORM_FIELD_TYPES: ApiFieldTypeOption[] = [
  { value: "text", label: "Текст" },
  { value: "email", label: "Email" },
  { value: "textarea", label: "Многострочный" },
  { value: "number", label: "Число" },
  { value: "phone", label: "Телефон" },
  { value: "date", label: "Дата" },
  { value: "date-range", label: "Интервал дат" },
  { value: "birthdate", label: "Дата рождения" },
  { value: "choice", label: "Выбор" },
  { value: "select", label: "Выпадающий список" },
  { value: "multiple-choice", label: "Несколько вариантов" },
  { value: "city", label: "Город" },
  { value: "fio", label: "ФИО" },
  { value: "privacy", label: "Согласие (ПДн)" },
  { value: "display", label: "Оформление" },
];

export const DEFAULT_API_FIELD_TYPES = FORM_FIELD_TYPES;

export function isConsentFieldType(type: string | null | undefined): boolean {
  return resolveFieldType(type) === "privacy";
}

export function isDisplayFieldType(type: string | null | undefined): boolean {
  return resolveFieldType(type) === "display";
}

export function labelForApiFieldType(value: string, fallback?: string): string {
  const key = resolveFieldType(value);
  return FIELD_TYPE_LABELS[key] ?? fallback?.trim() ?? value;
}

export function builderFieldTypeOptions(
  apiTypes: ApiFieldTypeOption[] = FORM_FIELD_TYPES,
): ApiFieldTypeOption[] {
  return apiTypes.map((item) => ({
    value: item.value,
    label: labelForApiFieldType(item.value, item.label),
  }));
}

/** В квизе типы с вариантами (баллы) идут первой группой. */
export function builderFieldTypeOptionsForMode(
  apiTypes: ApiFieldTypeOption[] = FORM_FIELD_TYPES,
  quizMode = false,
): ApiFieldTypeOption[] {
  const options = builderFieldTypeOptions(apiTypes);
  if (!quizMode) return options;

  const scored: ApiFieldTypeOption[] = [];
  const other: ApiFieldTypeOption[] = [];
  for (const option of options) {
    if (isListFieldType(option.value)) {
      scored.push({ ...option, group: QUIZ_SCORE_FIELD_TYPE_GROUP });
    } else {
      other.push({ ...option, group: QUIZ_OTHER_FIELD_TYPE_GROUP });
    }
  }
  return [...scored, ...other];
}

export function toApiFieldType(builderType: string): string {
  const resolved = resolveFieldType(builderType);
  if (resolved === "privacy") return "privacy";
  return String(builderType).trim().toLowerCase();
}

export function isKnownFieldType(type: string): boolean {
  const normalized = toApiFieldType(type);
  return FORM_FIELD_TYPES.some((item) => item.value === normalized);
}
